import type { BlocksList } from '~/composables/useBlocksList/types';

const blocksList = {
  tabs: {
    category: 'tabs',
    accessControl: ['content', 'productCategory', 'product'],
    title: 'Tabs',
    blockName: 'Tabs',
    variations: [
      {
        title: 'Tabs',
        image: 'https://cdn02.plentymarkets.com/v5vzmmmcb10k/frontend/PWA/placeholder-image.png',
        template: {
          en: {
            name: 'Tabs',
            type: 'structure',
            meta: { uuid: '5b6f4d2e-18af-43dc-9c7f-1a8af0e8c101' },
            configuration: {
              layout: {
                fullWidth: false,
                showBorderUnderTabs: true,
                tabsAlignment: 'left',
              },
            },
            content: [
              {
                name: 'TextCard',
                type: 'content',
                meta: { uuid: 'f2f26f36-6eb8-4f44-bb07-4c3094d6b201' },
                content: {
                  text: {
                    title: 'Tab 1',
                    htmlDescription: '<p style="text-align: left;">Add your tab content here.</p>',
                    textAlignment: 'left',
                    color: '#000',
                  },
                  button: {
                    label: '',
                    link: '',
                    variant: 'primary',
                  },
                  layout: {
                    fullWidth: false,
                  },
                },
              },
            ],
          },
          de: {
            name: 'Tabs',
            type: 'structure',
            meta: { uuid: '0f75a405-f99b-48dc-ac27-30a42ea55058' },
            configuration: {
              layout: {
                fullWidth: false,
                showBorderUnderTabs: true,
                tabsAlignment: 'left',
              },
            },
            content: [
              {
                name: 'TextCard',
                type: 'content',
                meta: { uuid: '7377427d-650e-462d-9c48-ae70691fdb0f' },
                content: {
                  text: {
                    title: 'Tab 1',
                    htmlDescription: '<p style="text-align: left;">Fuegen Sie hier Ihren Tab-Inhalt hinzu.</p>',
                    textAlignment: 'left',
                    color: '#000',
                  },
                  button: {
                    label: '',
                    link: '',
                    variant: 'primary',
                  },
                  layout: {
                    fullWidth: false,
                  },
                },
              },
            ],
          },
        },
      },
    ],
  },
};

export const getBlocksList = (): BlocksList => blocksList as unknown as BlocksList;